import { BroadcastEventType } from '@cotera/api';
import { emit } from './broadcast-event-bus';

/**
 * Broadcasts a chat-bot-config-updated event after Slack channel or Linear team
 * agent mappings change. Server emits the same event over WebSocket; clients
 * also emit locally after a successful save for immediate UI refresh.
 */
export function emitChatBotConfigUpdated(
  orgId: string,
  bot: 'slack' | 'linear' | 'teams'
): void {
  emit(BroadcastEventType.ChatBotConfigUpdated, { orgId, bot });
}
